import type { Theme } from '@emotion/react';
import { buildTheme } from 'common-ui';
import merge from 'lodash/merge';
import type { CommonThemeVars, ThemeCreateFunction } from 'tsconfig/types';
import { buildThemeVarsAPACVir, buildThemeMixinsAPACVir, buildThemeWidgetStylesAPACVir } from 'dw-apac-vir/theme';

const createTheme: ThemeCreateFunction = () =>
  buildTheme(
    (vars: Pick<Theme, CommonThemeVars>) => merge({}, buildThemeVarsAPACVir(vars)),
    (vars: Omit<Theme, 'mixins' | 'widgets'>) => buildThemeMixinsAPACVir(vars),
    (vars: Omit<Theme, 'widgets'>) => buildThemeWidgetStylesAPACVir(vars),
  );

export default createTheme;
